import React from 'react';
import { Crown, Download, PenLine, Sparkles } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

const COPY = {
  export: {
    title: 'Your Customized Bracket Is Ready!',
    body: 'Upgrade to Schedule Guru Pro to print or download your professionally customized bracket. Plus, unlock powerful tools for managing teams, schedules, standings, statistics, and entire sports leagues.',
    primary: 'Upgrade to Pro', blank: true,
    note: 'Your names, title and date stay saved in this browser. Your logo stays until you close the browser.',
  },
  lists: {
    title: 'Fill Brackets in One Click',
    body: 'Upgrade to Schedule Guru Pro to save team lists and drop the teams from your leagues into any bracket template. Plus, print and download customized brackets with no watermark.',
    primary: 'Upgrade to Pro', blank: false,
  },
  viewonly: {
    title: 'Printing Is Off for This Bracket',
    body: 'This bracket was made on Schedule Guru Free, so it can be viewed here but not printed or downloaded. You can print a blank bracket of the same size for free, or make your own customized bracket.',
    primary: 'Make Your Own Bracket', blank: true, icon: PenLine,
  },
  scores: {
    title: 'Keep Score Right on the Bracket',
    body: 'Upgrade to Schedule Guru Pro to type scores into any game. Winners move into the next round on their own, and your share link shows every result.',
    primary: 'Upgrade to Pro', blank: false,
  },
  manage: {
    title: 'Run This Bracket as a Tournament',
    body: 'Upgrade to Schedule Guru Pro to turn this bracket into a managed tournament with game times, courts, live scores, sport stats, box scores, officials and a public results page.',
    primary: 'Upgrade to Pro', blank: false,
  },
};

// `kind`: export | lists | viewonly (null = closed).
export const UpgradePrompt = ({ kind, onClose, onPrimary, onBlank, blankBusy }) => {
  const k = COPY[kind] || COPY.export;
  const Icon = k.icon || Crown;
  return (
    <Dialog open={!!kind} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="sm:max-w-md overflow-hidden p-0" data-testid="bracket-upgrade-prompt">
        <div className="bg-[#00247D] px-6 pt-6 pb-5 text-white relative">
          <DialogHeader className="text-left space-y-2">
            <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
              <Sparkles className="w-5 h-5 text-[#F5C542]" />
            </div>
            <DialogTitle className="text-2xl font-bold text-white pr-8" style={{ fontFamily: 'Barlow Condensed' }} data-testid="bracket-upgrade-title">
              {k.title}
            </DialogTitle>
            <DialogDescription className="text-sm text-white/85 leading-relaxed" data-testid="bracket-upgrade-body">{k.body}</DialogDescription>
          </DialogHeader>
        </div>
        <div className="px-6 py-5 flex flex-col gap-3">
          <Button onClick={onPrimary} className="h-11 bg-[#CF142B] hover:bg-[#A81022] font-bold transition-[background-color,transform] active:scale-[0.98]"
            data-testid="bracket-upgrade-btn">
            <Icon className="w-4 h-4 mr-2" />{k.primary}
          </Button>
          {k.blank && (
            <Button variant="outline" onClick={onBlank} disabled={blankBusy} className="h-11" data-testid="bracket-download-blank-btn">
              <Download className="w-4 h-4 mr-2" />Download Blank Bracket Free
            </Button>
          )}
          {k.note && <p className="text-xs text-slate-500 text-center">{k.note}</p>}
        </div>
      </DialogContent>
    </Dialog>
  );
};
